export enum CustomerDetailsPlacement {
  Chats = 'Chats',
  Customers = 'Customers',
  Archives = 'Archives',
  Tickets = 'Tickets',
}

export enum CustomerDetailsDefaultSectionEnum {
  GeneralInfo = 'generalInfo',
  AdditionalInfo = 'additionalInfo',
  VisitedPages = 'visitedPages',
  ChatSummary = 'chatSummary',
  Prechat = 'prechat',
  Postchat = 'postchat',
  Tickets = 'tickets',
  Technology = 'technology',
  IntegrationsData = 'integrationsData',
  Facebook = 'facebook',
}

export enum CustomerDetailsDefaultSectionTitleEnum {
  GeneralInfo = 'General info',
  AdditionalInfo = 'Additional info',
  VisitedPages = 'Visited pages',
  ChatSummary = 'Chat summary',
  Prechat = 'Pre-chat form',
  Postchat = 'Post-chat form',
  Tickets = 'Tickets',
  Technology = 'Technology',
  IntegrationsData = 'Integrations data',
  Facebook = 'Facebook',
}

enum CustomerDetailsDefaultSectionSelected {
  GeneralInfo = 'generalInfo',
  AdditionalInfo = 'additionalInfo',
  VisitedPages = 'visitedPages',
}

export const CUSTOMER_DETAILS_DEFAULT_SECTIONS: string[] = Object.keys(CustomerDetailsDefaultSectionEnum).map(
  (key) => CustomerDetailsDefaultSectionEnum[key] as string,
);

export const CUSTOMER_DETAILS_DEFAULT_SECTIONS_SELECTED: string[] = Object.keys(
  CustomerDetailsDefaultSectionSelected,
).map((key) => CustomerDetailsDefaultSectionSelected[key] as string);

export const CUSTOMER_DETAILS_WIDGET_ID = 'customer_details';
export const MARKETPLACE_WIDGET_ID = 'marketplace';
